import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import {
  Box,
  Button,
  Grid,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';

import WhatsappSrc from '../../../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../../../assets/img/whatsapp.png';
import Dropzone from '../../../../components/Dropzone/Dropzone.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { appConfig } from '../../../../config/app';
import { VehicleInspectionInfo } from '../../../../constants/selfInspections.constant';
import { useSelfInspectionDataContext } from '../../../../context/SelfInspection/selfInspection.provider';
import {
  SELF_INSPECTIONS_QUERY,
  SELF_INSPECTIONS_QUERY_CONFIG,
  selfInspectionsQuery,
} from '../../../../query/selfInspections/selfInspections';

// TODO: move to component to avoid repeat logic
const InsideInspectionElement = ({ onAction, image, buttonLabel }: any) => {
  return (
    <>
      {/* <img src={image} alt="izquierdo" /> */}
      <Box my={3}>
        <Button variant="contained" color="primary" onClick={onAction}>
          {buttonLabel}
        </Button>
      </Box>
    </>
  );
};

const VehiclePart = ({ vehiclePart }: any) => {
  const { success, errors, nextStep, validatePhoto, selectedInspection } =
    useSelfInspectionDataContext();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const [file, setFile] = useState('');
  const [open, setOpen] = useState(false);

  // Pasar a infinity query
  const { data: selfInspections } = useQuery(
    SELF_INSPECTIONS_QUERY,
    selfInspectionsQuery,
    SELF_INSPECTIONS_QUERY_CONFIG
  );

  const { vehicle } = selectedInspection;

  const selfInspection = selfInspections?.pages
    ? selfInspections?.pages
        ?.flat()
        .filter(
          (selfInspection: any) =>
            selfInspection.vehicle.license_plate === vehicle.license_plate
        )
    : selfInspections?.filter(
        (selfInspection: any) =>
          selfInspection.vehicle.license_plate === vehicle.license_plate
      );

  const VehicleInfo =
    VehicleInspectionInfo[selectedInspection.vehicle.type][vehiclePart.side];

  const handlingNext = (skipped: boolean = false) => {
    if (
      selfInspection[0].vehicle.parts.filter(
        (side: any) => side.id === vehiclePart.id
      )[0].photo &&
      !file
    ) {
      nextStep();
    } else {
      let nextStepInfo = {
        ...vehiclePart,
        photo_id: vehiclePart.id,
        photo: file || null,
        skipped,
      };

      let formData = new FormData();

      formData.append('id', vehiclePart.id);
      formData.append('photo', file);
      formData.append('skipped', new Boolean(skipped).toString());

      validatePhoto(formData, nextStepInfo);
    }
  };

  // const disableCamera = (disable: boolean) => {
  //   setIsDisableCamera(disable);
  // };

  useEffect(() => {
    if (success.validate_photo) {
      nextStep();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  useEffect(() => {
    if (errors.validate_photo) {
      setOpen(true);
    }
  }, [errors]);

  return (
    <>
      <SharedDialog
        open={open}
        onClose={() => setOpen(false)}
        content={
          <Box>
            <Box mb={2}>
              <Typography variant="h6">
                ¡Lo sentimos! no pudimos procesar correctamente tus fotos
              </Typography>
              <Typography variant="body2">
                Podés reintentar en unos instantes o comunicarte con nosotros
                por Whatsapp para cargar tu inspección
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Link
                  href={appConfig?.WHATSAPP_LINK}
                  rel="noopener"
                  target="_blank"
                >
                  <Button
                    variant="outlined"
                    fullWidth
                    color="secondary"
                    // onClick={() => handleSubmit}
                  >
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px' }}
                    />
                    <Typography display="inline">
                      Comunicarme vía Whatsapp
                    </Typography>
                  </Button>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => setOpen(false)}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <Grid container>
        <Grid item xs={12}>
          <Box my={2}>
            <Typography variant="h6">{VehicleInfo?.title}</Typography>
          </Box>
          <Box mb={3}>
            {!matches && (
              <Typography variant="body1">
                Revisá que no esté borrosa, cortada, y ni oscura.
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={10}>
          {selfInspection[0].vehicle.parts.filter(
            (side: any) => side?.id === vehiclePart?.id
          )[0].photo ? (
            <Dropzone
              onChange={(file: string) => setFile(file)}
              onNext={handlingNext}
              optional={vehiclePart?.optional}
              getFile
              disabled={false}
            >
              <InsideInspectionElement
                image={
                  selfInspection[0].vehicle.parts.filter(
                    (side: any) => side?.id === vehiclePart?.id
                  )[0].photo ||
                  vehicle.parts.filter(
                    (side: any) => side?.id === vehiclePart?.id
                  )[0].photo ||
                  VehicleInfo?.image
                }
                buttonLabel={VehicleInfo?.continueBtnLabel}
              />
            </Dropzone>
          ) : (
            <Dropzone
              onChange={(file: string) => setFile(file)}
              onNext={handlingNext}
              optional={vehiclePart.optional}
              getFile
            >
              <InsideInspectionElement
                image={VehicleInfo.image}
                buttonLabel={VehicleInfo.continueBtnLabel}
              />
            </Dropzone>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default VehiclePart;
